/**
 * Contexto dos slots de mensagem (conteúdo e rodapé da bolha, reações, menu).
 *
 * Fora do JSX e testável: é o contrato que todo plugin que desenha na bolha
 * recebe, e o `MessagesList` só chama.
 *
 * `metadata` é o espaço de cada plugin na mensagem (`pluginId → chave → valor`,
 * ver `core-contracts/domains/message.ts`). O app passa adiante e **não lê
 * dentro** — quem dá sentido ao conteúdo é o plugin, na própria UI.
 *
 * `channel` é o que permite ao plugin agir só nas mensagens dele: indispensável
 * para quem esconde o corpo nativo, senão apagaria o texto de todos os canais.
 */
export const messageSlotContext = message => ({
  messageId: message.id,
  ticketId: message.ticketId,
  body: message.body,
  fromMe: message.fromMe,
  mediaUrl: message.mediaUrl,
  createdAt: message.createdAt,
  channel: message?.ticket?.channel,
  whatsappId: message?.ticket?.whatsappId,
  wid: message.wid,
  isGroup: message?.ticket?.isGroup,
  metadata: message.metadata
});
